var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1298_23694"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "phone",
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "phone",
    width: 24,
    height: 24,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1298_23694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.37988 8.85327C8.32031 8.72876 8.29004 8.66626 8.26758 8.5874C8.18555 8.30713 8.24414 7.96289 8.41406 7.72534C8.46191 7.65869 8.51953 7.60132 8.63379 7.48706C8.9834 7.13745 9.1582 6.96265 9.27246 6.78687C9.70312 6.12402 9.70312 5.26953 9.27246 4.60645C9.1582 4.43066 8.9834 4.25586 8.63379 3.90625L8.43848 3.71143C7.90723 3.18018 7.6416 2.91431 7.35645 2.77002C6.78906 2.48291 6.11816 2.48291 5.55078 2.77002C5.26562 2.91431 5 3.18018 4.46875 3.71143L4.31055 3.86914C3.78125 4.39868 3.5166 4.66357 3.31445 5.02368C3.08984 5.4231 2.92871 6.0437 2.92969 6.50171C2.93066 6.91479 3.01074 7.19702 3.1709 7.76147C4.03223 10.7949 5.65625 13.6572 8.04492 16.0452C10.4326 18.4331 13.2949 20.0576 16.3281 20.9187C16.8926 21.0789 17.1748 21.1589 17.5879 21.1602C18.0459 21.1616 18.667 21.0002 19.0664 20.7756C19.4258 20.5735 19.6914 20.3086 20.2207 19.7791L20.3779 19.6213C20.9102 19.0898 21.1758 18.8242 21.3203 18.5388C21.6064 17.9712 21.6064 17.301 21.3203 16.7334C21.1758 16.448 20.9102 16.1824 20.3779 15.6509L20.1836 15.4561C19.834 15.1064 19.6592 14.9316 19.4834 14.8174C18.8203 14.3865 17.9658 14.3865 17.3027 14.8174C17.127 14.9316 16.9521 15.1064 16.6025 15.4561C16.4883 15.5703 16.4316 15.6274 16.3643 15.6753C16.127 15.8455 15.7832 15.9041 15.502 15.8223C15.4238 15.7993 15.3613 15.7695 15.2363 15.7095C13.7871 15.0137 12.4277 14.0647 11.2266 12.8633C10.0254 11.6616 9.07617 10.303 8.37988 8.85327Z",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.6bdb46c0679269b016b49ea481466f45.svg";
export { ForwardRef as ReactComponent };